import React from 'react';
const problems = [{
  title: '😰 INFORMATION IS EVERYWHERE...',
  lines: ['Home Assistant. Matter. Zigbee. Thread. Wi-Fi. ESPHome. Sensors. Automations.', "You jump between videos, forums, and tutorials, but there's no clear path showing you what to learn and in what order."]
}, {
  title: '⚠️ AFRAID OF EXPENSIVE MISTAKES',
  lines: ['Wrong devices. Compatibility problems. Failed connections. Unreliable automations.', 'Without a structured process, even a simple installation can become confusing.']
}, {
  title: '🔌 NO CLEAR INSTALLATION PROCESS',
  lines: ['Which devices should you choose? How should everything connect? How do you plan, automate, test, and deliver the system?', 'Professional installations require a repeatable process from planning to final delivery.']
}, {
  title: '😩 TURNING THE SKILL INTO A SERVICE FEELS COMPLICATED',
  lines: ["Knowing the technology isn't enough.", 'You also need to understand how projects are organized, quoted, documented, presented, and delivered professionally.']
}];
export function PainSection() {
  return <section className="border-y border-brand-line bg-brand-light px-4 py-5" data-id="element-115" data-mp="3rovfr1f5eqcb">
      <div className="mx-auto max-w-4xl" data-id="element-116" data-mp="3nl5uaktrsovi">
        <h2 className="mb-2 text-center font-display text-xl font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-117" data-mp="5fkfb0o7y04p">
          Does This Sound Familiar?
        </h2>
        <div className="mx-auto mb-3 max-w-3xl space-y-1 text-center text-sm font-normal leading-snug text-brand-muted sm:text-base" data-id="element-118" data-mp="emzguqoli6d">
          <p data-id="element-119" data-mp="33xq1gqouw644">
            You want to learn Smart Home installation — whether you're starting from zero or you're
            an electrician, technician, security installer, or DIY enthusiast expanding your skills.
          </p>
          <p data-id="element-120" data-mp="3dukwgzlx7odn">But once you start researching, everything becomes more complicated than expected.</p>
        </div>

        <div className="grid gap-2.5 sm:grid-cols-2" data-id="element-121" data-mp="2q4gusxsalypa">
          {problems.map(problem => <article key={problem.title} className="rounded-xl border border-brand-line bg-white p-3 shadow-sm" data-id="element-122" data-mp="2l5x8gw9sekwe">
              <h3 className="mb-1 font-display text-[13px] font-bold leading-tight text-brand-ink sm:text-base" data-id="element-123" data-mp="p30vhcyg7hzo">
                {problem.title}
              </h3>
              {problem.lines.map(line => <p key={line} className="mt-0.5 text-xs font-normal leading-snug text-brand-muted sm:text-sm" data-id="element-124" data-mp="yuojt4zpkiwx">
                  {line}
                </p>)}
            </article>)}
        </div>
      </div>
    </section>;
}